import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { photoApprovalColumns } from "../../tables/photoApprovalColumns";
import AdminDataTable from "../../components/common/AdminDataTable";
import ViewPhotoPopup from "./ViewPhotoPopup";
import { can } from "../../utils/can";
import toast from "../../utils/toast";

export default function PhotoApproval() {
  const PAGE_SIZE = 10;

  const [sortBy, setSortBy] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const [memberData, setMemberData] = useState(null);
  const [member, setMember] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  // filters
  const [name, setName] = useState("");
  const [emailMobile, setEmailMobile] = useState("");
  const [profileId, setProfileId] = useState("");

  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";



  const fetchMember = async (overrides = {}) => {
    setListLoading(true);

    const {
      page: pageOverride,
      limit: limitOverride,
      sortBy: sortByOverride,
      sortOrder: sortOrderOverride,
      name: nameOverride,
      emailMobile: emailMobileOverride,
      profileId: profileIdOverride,
    } = overrides;

    try {
      const queryParams = new URLSearchParams({
        page: pageOverride ?? page,
        limit: limitOverride ?? pageSize,
        sortBy: sortByOverride ?? sortBy,
        sortOrder: sortOrderOverride ?? sortOrder,
        name: nameOverride ?? name,
        emailMobile: emailMobileOverride ?? emailMobile,
        profile_id: profileIdOverride ?? profileId,
      }).toString();

      const response = await fetch(
        `${API_URL}/api/admin/profile-management/get-photo-approval?${queryParams}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.success) {
        setMember(result.data || []);
        const totalPagesCalc = Math.ceil(
          (result.totalCount || 0) / (pageSize || PAGE_SIZE)
        );

        setTotalPages(totalPagesCalc || 1);
      } else {
        setMember([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.log("Error fetching members:", error);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    if (can("photo_approval", "view") === false) {
      window.location.href = "/admin/dashboard";
      toast.showError("You don't have permission to view photo approval.");
      return;
    }

    fetchMember();
  }, [page, pageSize, sortBy, sortOrder]);


  const handlePhotoStatusUpdate = () => {
    // Refresh the member list after photo status change
    fetchMember();
  };

  const openModal = (row) => {
    setMemberData(row);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setMemberData(null);
  };

  const clearFilters = () => {
    setProfileId("");
    setName("");
    setEmailMobile("");
    setPage(1);
    fetchMember({ page: 1, profileId: "", name: "", emailMobile: "" });
  };

  const columns = photoApprovalColumns({ PAGE_SIZE, viewPhoto: openModal });

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Waiting for Photo Approval" />

        <div className="right_col" role="main">


          <div className="x_panel">
            <div className="x_title">
              <h2>Photo Approval</h2>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              {/* FILTER */}
              <div className="filtercont">
                <div className="row">
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-sm-4">
                        <label>Profile ID</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileId}
                          onChange={(e) => setProfileId(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-4">
                        <label>Search By Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label>Email / Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          value={emailMobile}
                          onChange={(e) => setEmailMobile(e.target.value)}
                        />
                      </div>


                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="col-12 pr-lg-0 d-flex align-items-end" style={{ "marginTop": 25 }}>
                      <button
                        className="btn btn-default submit sitebtn px-3 mr-2"
                        onClick={() => {
                          if (page !== 1) {
                            setPage(1);
                          } else {
                            fetchMember({ page: 1 });
                          }
                        }}
                      >
                        Search
                      </button>
                      <button
                        className="btn-small btn-secondary sitebtn  px-3"
                        onClick={clearFilters}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <p>{JSON.stringify(member.map((item) => item.mobile))}</p> */}


              {/* TABLE */}
              <AdminDataTable
                columns={columns}
                data={member}
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                loading={listLoading}
                onPageChange={setPage}
                onPageSizeChange={(size) => {
                  setPageSize(size);
                  setPage(1);
                  fetchMember({ page: 1, limit: size });
                }}
                sortBy={sortBy}
                sortOrder={sortOrder}
              />

              {isOpen && memberData && (
                <ViewPhotoPopup
                  key={memberData?._id || "photo-approval-modal"}
                  memberData={memberData}
                  isOpen={isOpen}
                  closePopup={closeModal}
                  onPhotoStatusChange={handlePhotoStatusUpdate}
                />
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
